import { registerModal } from 'features/Modal/ModalRegistry'
import { PhoneSystemExtensionEditFormModal } from './PhoneSystemExtensionEditFormModal'
import { showModal } from 'features/Modal/Modal.actions'
import { IExtensionFormData } from '../PhoneSystemExtensionEditForm/PhoneSystemExtensionEditForm.container'

export interface IPhoneSystemExtensionEditFormModal extends IExtensionFormData {
  username: string
  password: string
  didNumbers: any
}

export const modalType = 'PHONE_SYSTEM_EXTENSION_EDIT_FORM_MODAL'
registerModal(modalType, PhoneSystemExtensionEditFormModal)
export const showPhoneSystemExtensionEditFormModal = (
  modalProps: IPhoneSystemExtensionEditFormModal
) =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {},
  })



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemExtensionEditFormModal/PhoneSystemExtensionEditFormModal.action.ts